<template>
  <UIModal class="UIFormIsDirtyModal" size="sm" @close="$emit('close')">
    <template #title>
      <div class="UIFormIsDirtyModal__title">
        <UIIcon
          class="UIFormIsDirtyModal__title-icon"
          name="exclamationCircleOutline"
        />
        Unsaved changes
      </div>
    </template>

    <template #content>
      <div class="UIFormIsDirtyModal__content">
        You’ve made changes that haven’t been saved. If you leave this page now,
        your changes will be lost.
      </div>
    </template>

    <template #actions>
      <UIButton theme="neutral" buttonStyle="text" @click="$emit('discard')">
        Leave & Discard changes
      </UIButton>
      <UIButton @click="$emit('close')">Keep editing</UIButton>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import UIButton from '../buttons/UIButton.vue'
import UIIcon from '../icons/UIIcon.vue'
import UIModal from '../modals/UIModal.vue'

defineEmits(['close', 'discard'])
</script>

<style lang="scss" scoped>
.UIFormIsDirtyModal {
  .UIFormIsDirtyModal__title {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    color: $color-warning-60;
  }

  .UIFormIsDirtyModal__title-icon {
    --size: 1.5rem;
    --color: #{$color-warning-60};
  }

  .UIFormIsDirtyModal__content {
    margin-left: 2rem;
  }
}
</style>
